import { clearCheckoutViewerSecret } from './isolated/checkout-viewer-secret';

// Dutchie Plus (isolated checkout) redirects the customer off-page via `window.location.href`
// on both success (after-submit.js) and error (use-cart-data-from-server.js) paths. Setting
// `location.href` doesn't unload the page synchronously -- other already-scheduled JS (like an
// in-flight `getCheckout` query erroring out around the same time as order creation succeeds)
// can still run and overwrite it with the error redirect before the browser navigates away. This
// state lets the error path check whether this checkout's success redirect already fired and bail
// out instead of clobbering it. It is checkout-scoped so a delayed redirect from checkout A cannot
// suppress an initial error or clear the capability for checkout B.
let succeededCheckoutId;

export function markPlusRedirectSucceeded(checkoutId) {
  if (!checkoutId) return;

  succeededCheckoutId = checkoutId;
  clearCheckoutViewerSecret(checkoutId);
}

export function hasPlusRedirectSucceeded(checkoutId) {
  return Boolean(checkoutId) && succeededCheckoutId === checkoutId;
}

// Test-only escape hatch for resetting the module-level state between test cases.
export function __resetPlusRedirectStateForTests() {
  succeededCheckoutId = undefined;
}
